module.exports = __webpack_public_path__ + "img/scorm-integration250.407c91b6.png";